const db = window.sqlitePlugin.openDatabase({name: 'storage.db', location: 'default'});

var CREATE_PRACTITIONER_TABLE = "CREATE TABLE IF NOT EXISTS practitioners (" +
    "id INTEGER, " +
    "name TEXT, " +
    "surname TEXT, " +
    "practice_number TEXT, " +
    "photo TEXT, " +
    "qualification TEXT, " +
    "title TEXT, " +
    "university TEXT " +
    ")";

var CREATE_CHAT_TABLE = "CREATE TABLE IF NOT EXISTS chats (" +
    "id INTEGER, " +
    "user_id INTEGER, " +
    "practitioner_id INTEGER, " +
    "date_started INTEGER, " +
    "date_ended INTEGER" +
    ")";

var CREATE_CHAT_MESSAGES_TABLE = "CREATE TABLE IF NOT EXISTS chat_messages (" +
    "id INTEGER, " +
    "chat_id INTEGER, " +
    "message TEXT, " +
    "type TEXT, " +
    "timestamp INTEGER, " +
    "practitioner_id INTEGER " +
    ")";

db.sqlBatch([
    CREATE_PRACTITIONER_TABLE,
    CREATE_CHAT_TABLE,
    CREATE_CHAT_MESSAGES_TABLE
], function () {
    console.log("CREATED TABLE SUCCESS");
}, function (error) {
    console.log("CREATED TABLE FAILURE");

    console.log(error);
});

var Repository = {
    Practitioner: {
        save(id, name, surname, practice_number, qualification, university, title, photo, successCB) {
            console.log("Saving practitioner");

            var self = this;

            this.find(id, function (res) {
                if (res == null) {
                    console.log("Practitioner not found");
                    self.create(id, name, surname, practice_number, qualification, university, title, photo, function (res) {
                        successCB(res);
                    })
                } else {
                    console.log("Practitioner found");
                    self.update(id, name, surname, practice_number, qualification, university, title, photo, function (res) {
                        successCB(res);
                    })
                }
            });
        },
        create(id, name, practice_number, qualification, university, successCB) {
            console.log("Creating practitioner");
            db.executeSql("INSERT INTO practitioners (id, name, surname, practice_number, qualification, university, title, photo) VALUES(?, ?, ?, ?, ?, ?, ?, ?)",
                [id, name, surname, practice_number, qualification, university, title, photo], function (result) {
                    successCB(result);
                }, function (error) {
                    console.log(error)
                }
            );
        },
        update(id, name, practice_number, qualification, university, successCB) {
            console.log("Updating practitioner");
            db.executeSql("UPDATE practitioners SET name=?, surname=?, practice_number=?, qualification=?, university=?, title=?, photo=? WHERE id=?",
                [name, surname, practice_number, qualification, university, title, photo, id], function (result) {
                    successCB(result);
                }, function (error) {
                    console.log('Practitioner update failed')
                    console.log(error)
                }
            );
        },
        find(id, successCB) {
            db.executeSql('SELECT * FROM practitioners WHERE id=? LIMIT 1', [id], function (rs) {
                if (rs.rows.length === 0) {
                    successCB(null);
                } else {
                    successCB(rs.rows.item(0));
                }
            }, function (error) {
                console.log('SELECT SQL statement ERROR: ' + error.message);
            });
        }
    },
    Chat: {
        save(id, user_id, practitioner_id, date_started, date_ended, successCB) {
            console.log("Saving chat");
            var self = this;

            this.find(id, function (res) {
                if (res == null) {
                    console.log("Chat not found");
                    self.create(id, user_id, practitioner_id, date_started, date_ended, function (res) {
                        successCB(res);
                    })
                } else {
                    console.log("Chat found");
                    self.update(id, user_id, practitioner_id, date_started, date_ended, function (res) {
                        successCB(res);
                    })
                }
            });
        },
        create(id, user_id, practitioner_id, date_started, date_ended, successCB) {
            console.log("Creating chat")
            db.executeSql("INSERT INTO chats (id, user_id, practitioner_id, date_started, date_ended) VALUES(?, ?, ?, ?, ?)",
                [id, user_id, practitioner_id, date_started, date_ended], function (result) {
                    successCB(result);
                }, function (error) {
                    console.log(error)
                }
            );
        },
        update(id, user_id, practitioner_id, date_started, date_ended, successCB) {
            console.log("Updating chat")
            db.executeSql("UPDATE practitioners SET user_id=?, practitioner_id=?, date_started=?, date_ended=? WHERE id=?",
                [user_id, practitioner_id, date_started, date_ended, id], function (result) {
                    successCB(result);
                }, function (error) {
                    console.log(error)
                }
            );
        },
        find(id, successCB) {
            db.executeSql('SELECT * FROM chats WHERE id=? LIMIT 1', [id], function (rs) {
                if (rs.rows.length === 0) {
                    successCB(null);
                } else {
                    successCB(rs.rows.item(0));
                }
            }, function (error) {
                console.log('SELECT SQL statement ERROR: ' + error.message);
            });
        },
        all(userId, successCB) {
            db.executeSql("SELECT " +
                "   c.id as chat_id, " +
                "   0 as chat_message_count, " +
                "   c.date_started as chat_start_date, " +
                "   c.date_ended as chat_date_dispositioned," +
                "   p.photo as practioner_photo, " +
                "   p.qualification as practioner_qualifications, " +
                "   p.name as practitioner_name, " +
                "   p.surname as practitioner_surname, " +
                "   p.title as practitioner_title," +
                "   p.university as practitioner_university, " +
                "   p.qualification as practioner_qualifications " +
                "FROM chats c " +
                "   JOIN practitioners p on p.id=c.practitioner_id " +
                "WHERE " +
                "   c.user_id=? " +
                "ORDER BY c.date_started DESC " +
                "LIMIT 50", [userId], function (result) {

                var data = [];

                for (var i = 0; i < result.rows.length; i++) {
                    data.push(result.rows.item(i));
                }

                successCB(data);
            }, function (error) {
                console.log(error);
            });
        }
    },
    Message: {
        save(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
            var self = this;

            this.find(id, function (res) {
                if (res == null) {
                    self.create(id, chat_id, message, type, timestamp, practitioner_id, function (res) {
                        successCB();
                    })
                } else {
                    self.update(id, chat_id, message, type, timestamp, practitioner_id, function (res) {
                        successCB();
                    })
                }
            });
        },
        create(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
            db.executeSql("INSERT INTO chat_messages (id, chat_id, message, type, timestamp, practitioner_id) VALUES(?, ?, ?, ?, ?, ?)",
                [id, chat_id, message, type, timestamp, practitioner_id], function (result) {
                    successCB(result);
                }
            );
        },
        update(id, chat_id, message, type, timestamp, practitioner_id, successCB) {
            db.executeSql(
                "UPDATE chat_messages SET chat_id=?, message=?, type=?, timestamp=?, practitioner_id=? WHERE id=?",
                [chat_id, message, type, timestamp, practitioner_id, id],
                function (result) {
                    successCB(result);
                }
            );
        },
        find(id, successCB) {
            db.executeSql('SELECT * FROM chat_messages WHERE id=? LIMIT 1', [id], function (rs) {
                if (rs.rows.length === 0) {
                    successCB(null);
                } else {
                    successCB(rs.rows.item(0));
                }
            }, function (error) {
                console.log('SELECT SQL statement ERROR: ' + error.message);
            });
        }
    },
    close() {
        db.close();
    }
}

module.exports = Repository;